import { createContext, ReactNode, useContext } from 'react'

import { stackingOrder } from 'src/shared/const/stackingOrder'

type CommonStackProps = {
  /*
   * Render prop, в который передается функция.
   * Функция принимает аргумент со значением z-index из текущего контекста.
   */
  children: (value: number) => ReactNode
  /*
   * Исходное значение для z-index.
   */
  value?: number
}

const StackingContext = createContext(stackingOrder.DEFAULT)

export const Stack = ({ children, value = stackingOrder.DEFAULT }: CommonStackProps) => {
  const previousValue = useContext(StackingContext)
  const currentValue = Math.max(value, previousValue)
  const nextValue = currentValue + 1

  return <StackingContext.Provider value={nextValue}>{children(currentValue)}</StackingContext.Provider>
}

/*
 * Использование z-index напрямую в компонентах может привести к конфликтам наложения, так как нет централизованного контроля.
 * Компонент Stack решает эту проблему, предоставляя словарь stackingOrder для управления z-index плавающих элементов (например, тултипов, модалок).
 * Это гарантирует корректное наложение: если тултип находится внутри модалки, его z-index будет на единицу больше, чем у модалки.
 */
